module.exports = __webpack_public_path__ + "img/Frame 5110.da22102b.jpg";